import { render, staticRenderFns } from "./openCmt.vue?vue&type=template&id=0c07b534&scoped=true&"
import script from "./openCmt.vue?vue&type=script&lang=js&"
export * from "./openCmt.vue?vue&type=script&lang=js&"
import style0 from "./openCmt.vue?vue&type=style&index=0&id=0c07b534&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c07b534",
  null
  
)

export default component.exports